/**
 * Shared visual style for the Q{n} pill — used both inline within the message
 * body (QuestionChip) and on the expanded card ordinal (QuestionCard). Keeping
 * this as the sole source of truth ensures the inline anchor and the card
 * label always look identical.
 */
export const QUESTION_PILL_VIEW_STYLE = {
  borderRadius: 999,
  overflow: 'hidden' as const,
  paddingHorizontal: 8,
  paddingVertical: 4,
};

type PillPalette = {
  background: Record<number, string>;
  primary: Record<number, string>;
  typography: { white: string };
};

/**
 * The Q{n} pill's fill and label, shared by the inline chip and the card ordinal so the two match.
 * `recommended` is the case layout's pill on the sender's own bubble, white with a dark green
 * label. Temporary with the layout switch.
 */
export function getQuestionPillColors(
  colors: PillPalette,
  position: 'left' | 'right',
  recommended: boolean
): { backgroundColor: string; textColor: string } {
  if (position === 'left') {
    return { backgroundColor: colors.primary[500], textColor: colors.typography.white };
  }

  if (recommended) {
    return { backgroundColor: colors.background[0], textColor: colors.primary[700] };
  }

  return { backgroundColor: colors.primary[300], textColor: colors.typography.white };
}
